import React from 'react';

import { Button, Dialog, DialogActions, DialogContent, DialogTitle, Tooltip } from '@mui/material';

type Props = {
  open: boolean;
  setOpen: (open: boolean) => void;
  onDeleteConfirm: () => void;
  isSeriesEventAction: boolean;
};

const DeleteConfirmationDialog: React.FC<Props> = ({ open, setOpen, onDeleteConfirm, isSeriesEventAction }) => {
  const handleDelete = () => {
    onDeleteConfirm();
    setOpen(false);
  };

  return (
    <Dialog open={open} onClose={() => setOpen(false)} closeAfterTransition={false}>
      <DialogTitle>{isSeriesEventAction ? 'Delete Event Series' : 'Delete Event'}</DialogTitle>
      <DialogContent>
        {isSeriesEventAction
          ? `Are you sure you want to delete this event series? This action cannot be
        undone.`
          : `Are you sure you want to delete this event? This action cannot be
        undone.`}
      </DialogContent>
      <DialogActions>
        <Tooltip title="Cancel">
          <Button onClick={() => setOpen(false)}>Cancel</Button>
        </Tooltip>
        <Tooltip title="Delete">
          <Button color="primary" onClick={handleDelete}>
            Delete
          </Button>
        </Tooltip>
      </DialogActions>
    </Dialog>
  );
};

export default DeleteConfirmationDialog;
